// Container imports
const {
  HIDE,
  SHOW,
  SUBMIT_FAILED,
  SUBMIT_SUCCESS
} = require('./actions')
const SMSModalRecord = require('./record')

function smsModalReducer(state, { type }) {
  switch (type) {
    case SHOW:
      return new SMSModalRecord({
        isVisible: true
      })
    case HIDE:
      return null
    case SUBMIT_FAILED:
      return state.merge({
        isSubmitFailed: true
      })
    case SUBMIT_SUCCESS:
      return state.merge({
        isSubmitSuccessful: true
      })
    default:
      return state
  }
}

module.exports = smsModalReducer
